<template>
  <div>
    <section class="orep-header mont">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../public/assets/images/mercer-logo-white.png"  height="250" width="300" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Realshield'"  src="../../public/assets/images/realshield-logo-blue.png" height="250" width="300" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'IBD'"  src="../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
        <img v-else  src="../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="auth-section">
              <p class="before p-0 text-left w-100">
                Welcome Back, {{ customerDetail.contactName }}.
              </p>
              <div class="row user-info-row">
                <div class="col-md-6 d-flex mt-3 flex-column">
                  <p>Your Information:</p>
                  <span>{{ customerDetail.contactName }}</span>
                  <span>{{ customerDetail.companyName }}</span>
                  <span>{{ customerDetail.address }}</span>
                  <span>{{ customerDetail.city }}, {{ customerDetail.state }} {{ customerDetail.zipCode }}</span>
                </div>
                <div v-if="getApplicantType === 'IBD'" class="col-md-6 d-flex mt-3 flex-column">
                  <span>
                    Your Renewal Application has been pre-filled with information from last year’s application in many places. Please review each answer for accuracy and ensure the data is up-to-date. Call IBDPro at 866.840.8004 or email us at mike@ibdpro.com
                  </span>
                </div>
              </div>

              <div class="row justify-content-end mt-5">
                <button class="action-btn mont spaced" type="button" @click="navigateToOne()">
                  Renew My Policy
                </button>
              </div>
              <div v-if="getApplicantType === 'OREP'" class="row justify-content-end">
                <button class="action-btn mont spaced" type="button" @click="navigateToNext('contact')">
                  Contact OREP
                </button>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "about",
    methods: {
      navigateToNext(routeName) {
        this.$router.push({
          name: routeName
        });
      },

      prev() {
        this.$router.push({
          name: "individual-appraiser-2"
        });
      },

      navigateToOne() {
        if (this.state.customerDetail.isGroupAppraiser) {
          this.$router.push({
            name: "group-appraiser-1"
          });
        }else if (this.state.customerDetail.isHomeInspector){
          this.$router.push({
            name: "home-inspector-1"

          });
        } else if (this.state.customerDetail.isIndividualAppraiser){
          this.$router.push({
            name: "individual-appraiser-1"

          });
        } else if (this.state.customerDetail.isAxApplication){
          this.$router.push({
            name: "ax-application-1"

          });
        }
        else if (this.state.customerDetail.isStandardApplication){
          this.$router.push({
            name: "standard-application-1"

          });
        } else if (this.state.customerDetail.isRcApplication){
          this.$router.push({
            name: "rc-application-1"

          });
        } else if (this.state.customerDetail.isRxApplication){
          this.$router.push({
            name: "rx-application-1"

          });
        } else if (this.state.customerDetail.isPiApplication){
          this.$router.push({
            name: "pi-application-1"

          });

        }
        else if (this.state.customerDetail.isPpiApplication) {
          this.$router.push({
            name: "ppi-application-1"

          });
        }
        else if (this.state.customerDetail.isSipApplication){
          this.$router.push({
            name: "sip-application-1"
          });
        }
        else if (this.state.customerDetail.isQuickQuoteApplication) {
          this.$router.push({
            name: "quick-quote-1"

          });
        }
        else if (this.state.customerDetail.isInsuranceAgentApplication){
          this.$router.push({
            name: "ibdpro-insurance-agent-application-1"
          });
        }
        else if (this.state.customerDetail.isMgaApplication){
          this.$router.push({
            name: "ibdpro-mga-application-1"
          });
        }
      },
    },
    computed: {
      customerDetail() {
        return this.$store.state.customerDetail.customerDetail;
      },
      state() {
        return this.$store.state.customerDetail;
      },
      errorMsg() {
        return this.$store.state.customerDetail.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        if (this.customerDetail.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (this.customerDetail.partnerName === 'Realshield'){
          return 'Realshield';
        }
        else if (this.customerDetail.partnerName === 'IBD'){
          return 'IBD';
        }
        else {
          return 'OREP';
        }
      },
      mounted() {
        $('html, body').animate({
          scrollTop: $('.presentation-container').offset().top
        }, 500);
      },
    },
  }
</script>

<style scoped>
  .auth-section {
    max-width: 700px;
    display: flex;
    flex-direction: column;
    margin: 70px auto;
    padding: 1rem;
  }
  .action-btn {
    width: 230px;
    text-align: center;
    height: 46px;
    border-radius: 5px;
    background-color: #5f6273;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    border: 0;
    cursor: pointer;
    margin: 10px 0;
  }
  .user-info-row > div > p {
    font-weight: bold;
    font-size: 18px;
    text-decoration: underline;
  }
  .user-info-row > div {
    line-height: 24px;
  }
</style>

